export const getFormattedDateYYYYMMDD = (iso: string, localTime : boolean = false) => {
  //if (!localTime && iso.indexOf('T') > 0)
  //  return iso.split('T')[0];

  const date = new Date(iso);
  date.setMinutes(date.getMinutes() + (localTime ? date.getTimezoneOffset() : 0));
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};
